export default __webpack_public_path__ + "static/media/ico_clear.009d4fc5.svg";